/*
 * Public API Surface of fs-is
 */

export * from './lib/'